export default {
	drawerState: true,
};
